import { Link, NavLink } from "react-router-dom";

export default function Sidebar() {
  const loginUser = JSON.parse(localStorage.getItem("userData"));
  return (
    <div className="sidebar">
      <div className="sidebar-inner">
        <div className="menu-top">
          <div className="side-logo d-flex align-items-center gap-2 mb-30">
            <img src="/image/d-logo.png" alt="" />
            <h3 className="mb-0">Accuracy Connect</h3>
          </div>
          <div className="side-menus">
            <div className="side-menu-item">
              <NavLink to="/dashborad">
                <span className="side-item-icon">
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 16.6668C17.5 16.8878 17.4122 17.0998 17.2559 17.256C17.0996 17.4123 16.8877 17.5001 16.6667 17.5001H3.33333C3.11232 17.5001 2.90036 17.4123 2.74408 17.256C2.5878 17.0998 2.5 16.8878 2.5 16.6668V7.76178C2.49995 7.6359 2.52842 7.51165 2.58326 7.39835C2.63811 7.28506 2.71791 7.18565 2.81667 7.10761L9.48333 1.84844C9.63046 1.73219 9.81249 1.66895 10 1.66895C10.1875 1.66895 10.3695 1.73219 10.5167 1.84844L17.1833 7.10678C17.2822 7.18491 17.3621 7.28444 17.4169 7.39789C17.4718 7.51135 17.5002 7.63576 17.5 7.76178V16.6668ZM5.83333 10.0001C5.83333 11.1052 6.27232 12.165 7.05372 12.9464C7.83512 13.7278 8.89493 14.1668 10 14.1668C11.1051 14.1668 12.1649 13.7278 12.9463 12.9464C13.7277 12.165 14.1667 11.1052 14.1667 10.0001H12.5C12.5 10.6632 12.2366 11.299 11.7678 11.7679C11.2989 12.2367 10.663 12.5001 10 12.5001C9.33696 12.5001 8.70107 12.2367 8.23223 11.7679C7.76339 11.299 7.5 10.6632 7.5 10.0001H5.83333Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Dashboard
              </NavLink>
            </div>
          </div>
        </div>
        <div className="menu-scrollable">
          <div className="side-menus mt-30">
            <div className="side-menu-heading mb-3">
              <p className="mb-0">Workspace</p>
            </div>
            <div className="side-menu-ul">
              {loginUser?.permissions
                ?.filter((val) => val?.show_in_menu === 1)
                ?.map((val, i) => (
                  <li className="side-menu-item " key={i}>
                    <NavLink to={val?.action_path}>
                      <span
                        className="side-item-icon"
                        dangerouslySetInnerHTML={{ __html: val?.icon }}
                      ></span>
                      {val?.navigation_name}
                    </NavLink>
                  </li>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar-footer">
        <p className="mb-1">Looking for something?</p>
        <Link to="#" className="text-decoration-underline">
          Help &amp; Support
        </Link>
      </div>
    </div>
  );
}
